export const cohortBuilderViewCardMessagesEn = {
  // Cohort Builder - index date selection (criterion card)
  'projects.cohortBuilder.indexDateSelection.label': 'Index date selection:',
  'projects.cohortBuilder.indexDateSelection.absolute':
    'Absolute {occurrence, select, first {first} last {last} other {{ordinal}}} occurrence',
  'projects.cohortBuilder.indexDateSelection.rolling':
    '{occurrence, select, first {First} last {Last} other {{ordinal}}} occurrence where all other criteria are also met',
  'projects.cohortBuilder.criterionCard.fixedCalendarIndexDate': 'Fixed calendar index date',
  'projects.cohortBuilder.criterionCard.definitionPending': 'Variable definition pending…',
  // Cohort Builder - View Card
  'projects.cohortBuilder.cohortBuilderItemViewCard.inUse': 'Used by:',
  'projects.cohortBuilder.cohortBuilderItemViewCard.notInUse': 'This item is not being used',
  'projects.cohortBuilder.cohortBuilderItemViewCard.deleteInUse':
    'Please remove all references to this item before deleting.',
  'projects.cohortBuilder.cohortBuilderItemViewCard.deleteNotInUse': 'Delete',
  'projects.cohortBuilder.cohortBuilderItemViewCard.status.new': 'New',
  'projects.cohortBuilder.cohortBuilderItemViewCard.status.updated': 'Updated',
  'projects.cohortBuilder.cohortBuilderItemViewCard.warning': 'This event may need your review',
  'projects.cohortBuilder.cohortBuilderItemViewCard.error': 'This event requires your attention',
  'projects.cohortBuilder.cohortBuilderItemViewCard.warningCriteria':
    'This criterion may need your review',
  'projects.cohortBuilder.cohortBuilderItemViewCard.errorCriteria':
    'This criterion requires your attention',
  'projects.cohortBuilder.cohortBuilderItemViewCard.errorIndexDate':
    'Index date requires your attention',
  'projects.cohortBuilder.cohortBuilderItemViewCard.errorStudyPeriod':
    'Study period requires your attention',

  // Action tooltip — disabled states (applies to both edit and delete)
  'projects.cohortBuilder.cohortBuilderItemViewCard.actionTooltip.processing':
    'This action is disabled because the cohort is currently processing.',
  'projects.cohortBuilder.cohortBuilderItemViewCard.actionTooltip.raProcessing':
    'This action is disabled because the Research Assistant is currently processing.',
  'projects.cohortBuilder.cohortBuilderItemViewCard.actionTooltip.saving':
    'This action is disabled because saving is currently in progress.',
};
